<template>
	<div class="login-container">
		<div class="login-layout">
			<div class="logo-box"><img src="../assets/images/login-logo.png"></div>
			<div class="title-box">后台管理系统</div>
			<div class="form-box">
				<div class="form-items">
					<label for="name">账号：</label>
					<input type="text" name="name" v-model="form.name.value" :placeholder="form.name.placeholder" autocomplete="off" @focus="inputFocus($event,'name')" @blur="inputBlur($event,'name')" />
					<span class="form-input-tip" v-if="form.name.showTip">{{form.name.tipText}}</span>
				</div>
				<div class="form-items">
					<label for="password">密码：</label>
					<input type="password" name="name" v-model="form.password.value" :placeholder="form.password.placeholder" autocomplete="off" @focus="inputFocus($event,'password')" @blur="inputBlur($event,'password')" />
					<span class="form-input-tip" v-if="form.name.showTip">{{form.name.tipText}}</span>
				</div>
				<div class="form-items" style="margin:0;padding:20px 0 0 0;">
					<a class="form-submit-but" href="javascript:void(0);" @click="loginFormSubmit($event)">登录</a>
				</div>
			</div>
		</div>
		   <!-- 网站备案链接  -->
        <div class="wangzhan_beian">
        <!-- <span>网站备案:</span> &nbsp; -->
        <a href="https://beian.miit.gov.cn" target="_blank">粤ICP备2022064963号</a>
   </div>
	</div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
	name: 'Login',
	props: [],
	components: {},
	computed: {
			...mapGetters([
				'pageTabs',
				'pageTabs_curIndex'
			])
		},
	data() {
		return {
			rememberPS:false,
			form: {
				name: {
					value: '',
					placeholder: '输入登陆帐号',
					showTip: false,
					tipText: ''
				},
				password: {
					value: '',
					placeholder: '输入登陆密码',
					showTip: false,
					tipText: ''
				},
				code: {
					value: '',
					placeholder: '输入验证码',
					showTip: false,
					tipText: ''
				}
			}
		}
	},
	created() {
		let that = this;
		document.onkeypress = function(e) {
			var keycode = document.all ? event.keyCode : e.which;
			if (keycode == 13) {
				that.loginFormSubmit();
				return false;
			}
		};
	},
	methods: {
		inputFocus(e, type) {

		},
		inputBlur(e, type) {

		},
		loginFormSubmit(e) {
			let data={};
			data.loginAccount=this.form.name.value;
			data.password=this.form.password.value;
			this.$store.dispatch('user/login', data).then(res => {
				sessionStorage.setItem('username',this.form.name.value)
				//this.getUserinfo();
				setTimeout(()=>{
					this.$store.dispatch('common/init')
					this.$router.push('/')
				},100)
			})
		},
		// 获取权限树
		getPermissionTree(){
			role.permissionTree((res)=>{
			})
		},
		// 获取用户权限
		getUserinfo(){
			this.$store.dispatch('user/getInfo').then(res => {
				console.log('获取用户信息成功')
				console.log(res)
			})
		},
		
		
	},
	mounted() { 
		this.form.name.value=sessionStorage.getItem('username') || '';
	}
}

</script>
<style scoped>
.wangzhan_beian {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  color: rgb(203, 199, 199);
}

.login-container {
  width: 100%;
  height: auto;
  /* min-height: 980px; */
  background: #FF5B3E;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-layout {
  width: 380px;
  /* height: 580px; */
  /* position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%); */
}

.logo-box {
  width: 100%;
  height: 74px;
}

.logo-box img {
  display: block;
  width: 193px;
  height: 74px;
  margin: 0 auto;
}

.title-box {
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 20px;
  color: #FFF;
}

.form-box {
  width: 80%;
  height: auto;
  background: #FFF;
  border-radius: 4px;
  padding: 10%;
}

.form-items {
  width: 100%;
  height: auto;
  margin: 0 0 20px 0;
  position: relative;
}

.form-items label {
  display: block;
  width: 100%;
  height: 30px;
  line-height: 30px;
  color: #383838;
}

.form-items input {
  display: block;
  width: 98%;
  height: 38px;
  line-height: 38px;
  color: #383838;
  padding: 0 0 0 1%;
  border: 1px solid #DCDCDC;
  text-indent: 8px;
}

.form-input-tip {
  display: block;
  width: 100%;
  height: 30px;
  line-height: 30px;
  position: absolute;
  left: 0;
  top: 80px;
}

.form-submit-but {
  display: block;
  width: 99%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border: 1px solid #FF5B3E;
  border-radius: 4px;
  background: #FF5B3E;
  color: #FFF;
}

</style>
